import { mutatorAction } from 'satcheljs';
import store from '../store/Store';

/*
 * Action to set the CheckBookingPagePublishedIsCalled
 */

export default mutatorAction(
    'setCheckBookingPagePublishedIsCalled',
    function setNewUserAutoPublishState(isCalled: boolean) {
        store.checkBookingPagePublishedIsCalled = isCalled;
    }
);
